define('ns', [], function () {
	'use strict';

	window.app = {};

	return window.app;
});

require([ 'ns', 'app' ], function (ns, App) {
	'use strict';

	var app = new App();

	if (typeof Object.freeze === 'function') {

		Object.freeze(ns);
	}

	if (typeof Object.seal === 'function') {

		_.each(ns, function (obj) {

			Object.seal(obj);
		});
	}
});
define("main", function(){});

